import React from 'react';
import { Link } from 'react-router-dom';
import screenshot1 from '../images/screenshot1.jpg';
import screenshot2 from '../images/screenshot2.jpg';
import semenuk from '../images/SemenukPic.jpg';
import '../CSS/Home.css';

function Home() {
    const linkStyle = { color: 'black', textDecoration: 'none', }

    return (
        <div className="page home">
            <section className="hero">
                <h1 className="title">MTB trail status</h1>
                <h2 className="subHeading">A Trail Report in Your Pocket.</h2>
                <Link style={linkStyle} to="/trails" className="heroButton">See The Trails</Link>
            </section>
            <section className="explanation">
                <div className="explanation__content">
                    <h2 className="content__heading">What Does This platform do?</h2>
                    <div className="content__p">
                        <p>This platform relies on the mountain bike community to provide info on the trails to others.</p>
                        <p>In a few clicks you can check the status and in just a few more you can update it.</p>
                    </div>
                    
                </div>
                <img className="explanation__img" src={semenuk} alt="random guy on bike"/>
            </section>
            <section className="screenshots">
                <h2 className="screenshots__heading title">Trail Status Is Just A few Clicks Away</h2>
                <div className="photoContainer">
                    <div className="photoContainer__element">
                        <h3 className="screenshotCaption">Viewing Trails Is Simple and Clutter Free</h3>
                        <img className="screenshot" src={screenshot1} alt=""/>
                    </div>
                    <div className="photoContainer__element">
                        <h3 className="screenshotCaption">A Simple UI for Updating Trail Status</h3>
                        <img className="screenshot" src={screenshot2} alt=""/>
                    </div>
                </div>
            </section>
            <section className="SignupSection">
                <h2 className="title">Interested? Sign up 100% free.</h2>
                <h3 className="Signup__subtitle">
                    In two clicks you can be up and running on our platform.
                    <br/>
                    Don't worry we don't store any of your data.    
                </h3>
                <Link className="SignupSection__button" to="/signin">Sign Up</Link>
            </section>
        </div>
    )
}

export default Home;